import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AbstractModel, AbstractModelImpl } from '@/services/common/abstract-model';
import type { ElementsState } from '../type/ai-search.type';

export const AISearchElementsModel = Symbol('AISearchElementsModel');

export interface AISearchElementsModel extends AbstractModel<ElementsState> {}

@injectable()
export class AISearchElementsModelImpl extends AbstractModelImpl<ElementsState> implements AISearchElementsModel {
    protected _modelData: ElementsState = {
        isLoading: false,
        summary: [],
        topic: {
            elements: [],
            relatedIpc: [],
        },
        element: {
            elements: [],
            relatedIpc: [],
        },
    };
}
